/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BookmarkedPressRelease,
    BookmarkedPressReleaseFromJSON,
    BookmarkedPressReleaseFromJSONTyped,
    BookmarkedPressReleaseToJSON,
} from './BookmarkedPressRelease';

/**
 * 
 * @export
 * @interface LatestPressReleasesResponseAllOfData
 */
export interface LatestPressReleasesResponseAllOfData {
    /**
     * 最新プレスリリース一覧
     * @type {Array<BookmarkedPressRelease>}
     * @memberof LatestPressReleasesResponseAllOfData
     */
    pressReleases: Array<BookmarkedPressRelease>;
    /**
     * 次のデータを取得する開始点となる識別子
     * @type {string}
     * @memberof LatestPressReleasesResponseAllOfData
     */
    nextCursor?: string;
    /**
     * 検索結果の総数
     * @type {number}
     * @memberof LatestPressReleasesResponseAllOfData
     */
    totalCount: number;
}

export function LatestPressReleasesResponseAllOfDataFromJSON(json: any): LatestPressReleasesResponseAllOfData {
    return LatestPressReleasesResponseAllOfDataFromJSONTyped(json, false);
}

export function LatestPressReleasesResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): LatestPressReleasesResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pressReleases': ((json['press_releases'] as Array<any>).map(BookmarkedPressReleaseFromJSON)),
        'nextCursor': !exists(json, 'next_cursor') ? undefined : json['next_cursor'],
        'totalCount': json['total_count'],
    };
}

export function LatestPressReleasesResponseAllOfDataToJSON(value?: LatestPressReleasesResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'press_releases': ((value.pressReleases as Array<any>).map(BookmarkedPressReleaseToJSON)),
        'next_cursor': value.nextCursor,
        'total_count': value.totalCount,
    };
}

